import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../hooks/useNotification';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useForm } from '../../../hooks/useForm';
import { useTranslation } from "react-i18next";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import moment from 'moment';
import { CurrencyExchangeSection } from '../../../components/invoice/CurrencyExchangeSection';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { ActionButtons } from '../../../components/others/ActionButtons';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { InvoiceFom } from '../components/InvoiceFom';
import { DianErrorsDialog } from '../../../components/invoice/shared/Dialogs/DianErrorsDialog.jsx';
import { ProductsForm } from '../../../components/invoice/shared/ProductsForm.js';
import { ClientForm } from '../../../components/invoice/shared/ClientForm.js';
import { Supplier } from '../../../components/invoice/shared/Supplier.js';
import { getAccessScreen } from '../../../services/common.services.js';
import { insert, getCompanies, update, fetchInvoiceId, fetchSendInvoice, fetchProductsInvoice } from "../../../services/invoice.services.js";

const model = {
    document_id: 'Asignado Automáticamente',
    id_company: '',
    id_company_supplier: '',
    company_supplier_name: '',
    id_company_receiver: '',
    id_office_receiver: '',
    address_delivery: '',
    currency: 'COP',
    other_currency: 'COP',
    products: [],
    id_payment_method: '',
    id_mean_of_payment: '',
    mean_of_payment_text:'',
    customization_id: '10',
    document_type_code: '01',
    retentions: [],
    ica_retention_rate: '',
    exchange_rate: 0,
    total_retentions: '',
    gross_total_value_other: '',
    retentions_total_other: '',
    payable_amount_other: '',
    order_reference: '',
    discount_other: '',
    resolution: '',
    observations: '',
    status_code: 'SAVED',
    created: '',
    updated: '',
    issue_date: moment(new Date()).format('YYYY/MM/DD'),
    order_reference_date: moment(new Date()).format('YYYY/MM/DD'),
    payment_due_date: moment(new Date()).format('YYYY/MM/DD'),
    expedition_date: moment(new Date()).format('YYYY/MM/DD'),
    exchange_rate_date: moment(new Date()).format('YYYY/MM/DD')
}

export const LayoutInvoice = () => {
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const otherCurrencyRef = useRef();
    const productsFormRef = useRef();
    const clientmRef = useRef();
    const invoiceRef = useRef();

    const [invoiceData, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(model);
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [refreshTotals, setRefreshTotals] = useState(null);
    const [supplierId, setSupplierId] = useState('');
    const [errorDian, setErrorDian] = useState(false);
    const [openDialogCompany, setOpenDialogCompany] = useState(false);    
    const [changeValueAccess, setChangeValueAccess] = useState(false);

    const fetchInvoiceData = useCallback(async (idInvoice) => {
        try {
          const [InvoiceRes, productsRes] = await Promise.all([
            fetchInvoiceId(idInvoice, userSession.token),
            fetchProductsInvoice(idInvoice, userSession.token)
          ]);
          if (InvoiceRes.status === 200 && productsRes.status === 200) {
            if (InvoiceRes?.data?.[0]) {
                const invoice = InvoiceRes.data[0];
                const parseDate = (dateStr) => dateStr ? moment(dateStr.split('T')[0], 'YYYY-MM-DD').toDate() : null;
                const order = {
                    ...invoice,
                    retentions: invoice.retentions ? invoice.retentions.split(',') : [],
                    payment_due_date: parseDate(invoice.payment_due_date),
                    expedition_date: parseDate(invoice.expedition_date),
                    order_reference_date: parseDate(invoice.order_reference_date),
                    issue_date: parseDate(invoice.issue_date),
                    exchange_rate_date: parseDate(invoice.exchange_rate_date),
                    // foreign_currency_value: Number(invoice.exchange_rate) > 0 ? 'YES' : 'NO',
                    products: productsRes.data || []
                };
                setAllInfo(order);
                setSupplierId(order.id_company_supplier || '');
                setEdit(true);
                setLoading(false);
            }
            else
                console.error("Error uploading data")
          }
        } catch (error) {
            console.error("Error fetching opportunity data:", error);
        }
    }, [userSession.token]);

    useEffect(() => {
        if (location.state && location.state.config) {
            const { data } = location.state.config || {};
            if (data?.work_flow === 'FLOW_PROCESS-VIEW_ORDER_REFERENCE') {
                setIsView(true);
            }

            if (data?.id) {
                setEdit(true);
                setLoading(true);
                setOpenDialogCompany(false);
                fetchInvoiceData(data.id)
            } else {
                const fetchData = async () => {
                    try {
                        setLoading(true);
                        const response = await getCompanies('23', userSession.token);
                        setCompanies(response.data || []);
                        if (response.data && response.data.length === 1) {
                            const dto = response.data[0];
                            setSupplierData(dto);
                            setOpenDialogCompany(false);
                        }
                        else
                            setOpenDialogCompany(true);
                    } catch (err) {
                        console.log(err.message);
                    } finally {
                        setLoading(false);
                    }
                };
                fetchData();
            }
        }
    }, [location.state, userSession.token, fetchInvoiceData]);

    useEffect(() => {
        if (invoiceData.id_company) {
            (async () => {
                try {
                    const response = await getAccessScreen(
                        'MENU-INVOICE',
                        invoiceData.id_company,
                        userSession.token
                    );
                    if (response.status === 200 && response?.data?.[0]) {
                        const data = response.data[0];
                        if (Array.isArray(data)) {
                            data.forEach((i) => {
                                if (i.work_flow === 'ACCESS-CHANGE-VALUE') 
                                    setChangeValueAccess(true);
                            });
                        } else {
                            if (data.work_flow === 'ACCESS-CHANGE-VALUE') 
                                setChangeValueAccess(true);
                        }
                    }
                } catch (err) {
                    console.error(err.message);
                }
            })();
        }
    }, [invoiceData.id_company, userSession.token]);

    const handleSubmit = async () => {
        const { allValid, isCreatingProduct } = await isValidForm();
        if (allValid) {
            setLoading(true);
            let json = { ...invoiceData, retentions: invoiceData.retentions.join(',')};
            const data = JSON.stringify(json);
            console.dir(data, { depth: null, colors: true });
            if (edit){
                await update(data, userSession.token);
            }else{
                await insert(userSession.token, data);
            }
            setLoading(false);
            sendNotification({ msg: t('messages.eventSucces'), variant: 'success'});
            Cancel();
        }
        else {
            if(!isCreatingProduct){
                sendNotification({ msg: t('validation.unsavedChanges'), variant: 'error'});
                return;
            }
            sendNotification({ msg: t('validation.requiredFieldsMissing'), variant: 'error' });
            return;
        }
    };

    const handleSubmitSend = async () => {
        const { allValid, isCreatingProduct } = await isValidForm();
        if (allValid) {
            const action = 'CREATE_JSON_DIAN_INVOICE'
            let json = { ...invoiceData, retentions: invoiceData.retentions.join(',')};
            const data = JSON.stringify(json);
            setLoading(true);
            if (!edit){
                const response = await insert(userSession.token, data);
                if (response && response.status === 200 && response?.data?.[0]) {
                    const id = response.data[0].id;
                    const responseSend = await fetchSendInvoice(userSession.token, id, action);
                    await handleResponseSend(responseSend, id);
                    setLoading(false);
                    return;
                }
            }else {
                await update(data, userSession.token);
                const responseSend = await fetchSendInvoice(userSession.token, invoiceData.id_electronic_document, action);
                await handleResponseSend(responseSend, invoiceData.id_electronic_document);
                setLoading(false);
            }
            setLoading(false);
        }
        else {
            if(!isCreatingProduct){
                sendNotification({ msg: t('validation.unsavedChanges'), variant: 'error'});
                return;
            }
            sendNotification({ msg: t('validation.requiredFieldsMissing'), variant: 'error' });
            return;
        }
    };

    const handleResponseSend = async (response, id) => {
        if(response && response.status === 200 && response?.data?.StatusCode !== '00' && response?.data?.ErrorMessage.length > 0){
            setErrorDian(response.data);
        }else{
            sendNotification({msg: t('messages.processRunning'), variant: 'success'});
            Cancel();
        }
    };


    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1);
    }

    const isValidForm = async () => {
        const isCreatingProduct = !productsFormRef.current?.getData().some(product => product.isCreated);
        const validations = await Promise.all([
            clientmRef.current?.validForm(),
            invoiceRef.current?.validForm(),
            productsFormRef.current?.validForm(),
            Promise.resolve(isCreatingProduct),
            // invoiceData.foreign_currency_value === 'YES'
            //     ? otherCurrencyRef.current?.validForm()
            //     : true
        ]);
        const allValid = validations.every(Boolean);
        return { allValid, isCreatingProduct };
    }

    const handleConfirmAction = useCallback(async (dto) => {
        setSupplierData(dto);
        setOpenDialogCompany(false);
    }, []);

    const setSupplierData = (dto) => {
        handleDirectInputChange('id_company', dto.id_company || '');
        handleDirectInputChange('company_supplier_name', dto.name || '');
        handleDirectInputChange('id_company_supplier', dto.id_number || '');
        setSupplierId(dto.id_number || '')
    }
    return (
        <>
            <Box sx={{ width: '90%', mx: 'auto' }}>
                <Typography variant="h4" gutterBottom>
                    {isView ? t('invoice.title')  : `${edit ? t('edit') : t('create')} ${t('invoice.title')}`}
                </Typography>
                <Card sx={{mb: 3}}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>{t('suppliers.supplierInofo')}</Typography>
                        <Supplier dto={invoiceData} />
                        <DividerGradient/>
                        <Typography variant="h6" gutterBottom>{t('client.clientInfo')}</Typography>
                        <ClientForm ref={clientmRef}
                            handleFieldChange={handleInputChange}
                            handleDirectChange={handleDirectInputChange}
                            isEdit={edit}
                            dto={invoiceData}
                        />
                        <DividerGradient/>
                        <Typography variant="h6" gutterBottom>{t('invoice.infoInvoice')}</Typography>
                        <InvoiceFom ref={invoiceRef}
                            supplierId={supplierId}
                            setRefreshTotals={setRefreshTotals}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={invoiceData || {}}
                        />
                        {/* {invoiceData.foreign_currency_value === "YES" && (
                            <>
                                <DividerGradient/>
                                <Typography variant="h6" gutterBottom>{t('invoice.infoOtherCurrency')}</Typography>
                                <CurrencyExchangeSection 
                                    ref={otherCurrencyRef}
                                    handleInputChange={handleInputChange}
                                    handleDirectInputChange={handleDirectInputChange}
                                    setRefreshTotals={setRefreshTotals}
                                    dto={invoiceData || {}}
                                />
                            </>
                        )} */}

                        <DividerGradient/>

                        <Typography variant="h6" gutterBottom>{t('crm.products.title')}</Typography>
                        <ProductsForm ref={productsFormRef}
                            handleDirectInputChange={handleDirectInputChange}
                            handleInputChange={handleInputChange}
                            refreshTotals={refreshTotals}
                            dto={invoiceData}
                            changeValueAccess={changeValueAccess}
                        />

                        <ActionButtons
                            onCancel={Cancel}
                            onSubmit={handleSubmit}
                            onSubmitOptional={handleSubmitSend}
                            disabledSubmit={isView}
                            labelOptional={t("send")}
                            disabledOptional={isView || (edit && invoiceData.status_code === 'APR')}
                        />
                    </CardContent>
                </Card>
            </Box>
            
            {loading && <LoadingOverlay isOpen={loading} />}
            {openDialogCompany && (
                <DialogSelectCompany
                    openDialogConfirm={openDialogCompany}
                    handleCancelConfirm={Cancel}
                    handleConfirmAction={handleConfirmAction}
                    data={companies}
                />
            )}
            
            {(errorDian && errorDian?.ErrorMessage) && (<DianErrorsDialog dianResponse={errorDian} onClose={() => setErrorDian(false)}/>)}
        </>
    );
};